import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectSprayWorksheetEntitySummariesTotalTanks } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

interface ConnectedProps {
    sumTotalTanks: string;
}

type Props = OwnProps & ConnectedProps;

export class SumTanksEstimatedTableCell extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { sumTotalTanks } = this.props;

        return <TableCell>{sumTotalTanks} (total)</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    sumTotalTanks: makeSelectSprayWorksheetEntitySummariesTotalTanks()
});

export default connect(mapStateToProps)(SumTanksEstimatedTableCell);
